const axios = require("axios");
export default {
  props: ["isLoggedIn"],

  data() {
    return {
      wishlistentries: null,
      isInWishlist: false,
    };
  },

  methods: {
    goToLogin(response, isInWishlist) {
      if (response.status === 200 && response.data === "") {
        this.isInWishlist = isInWishlist;
      } else if (response.data !== "") {
        window.location.href = "/login";
      }
    },
    deleteWishlist(product) {
      if (this.isLoggedIn) {
        axios({
          method: "get",
          url: "/wish/remove",
          params: {
            productCode: product.code,
          },
        }).then((response) => {
					this.updateSessionEntries(product, false);
					this.goToLogin(response, false);
        });
      } else {
        window.location.href = "/login";
      }
    },

    addWishList(product) {
      if (this.isLoggedIn) {
        axios({
          method: "get",
          url: "/wish/add",
          params: {
						productCode: product.code,
          },
        }).then((response) => {
					this.updateSessionEntries(product, true);
					this.goToLogin(response, true);
        });
      } else {
        window.location.href = "/login";
      }
    },

    isInWishListAction() {
      this.wishlistentries = this.$root.wishlistentries;
			if (this.wishlistentries && this.product) {
        this.isInWishlist = this.wishlistentries.some(
          (entry) => entry.product.code === this.product.code
        );
      }
    },

    deleteWishlistPage(productCode) {
      if (this.isLoggedIn) {
        axios({
          method: "get",
          url: "/wish/remove",
          params: {
            productCode: productCode,
          },
        }).then((response) => {
          if (response.status === 200) {
            window.location.reload();
          }
        });
      } else {
        window.location.href = "/login";
      }
		},
		updateSessionEntries(product, added) {
			var sessionEntries = JSON.parse(sessionStorage.getItem("wishlistentries"));
			added ? sessionEntries.push({ product: product }) : sessionEntries = _.filter(sessionEntries, function (entry) {
				return entry.product.code !== product.code;
			});
			sessionStorage.setItem("wishlistentries", JSON.stringify(sessionEntries));
		},
  },
  mounted: function() {
    if (!this.productPage) {
      this.$root.wishlistentriesFirst.then(this.isInWishListAction);
      this.$root.$on("wishlistentries-updated", this.isInWishListAction);
      this.$root.$emit("wishlistentries-called");
    }
  },
};



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/mixins/wishlistMixin.js